import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import cn from '@/utils/merge-class-names';

interface Props {
  className?: string;
}

export default function ProgressLayout({ className }: Props) {
  return <LoadingLayout className={cn('w-screen h-screen-safe max-h-dvh', className)} />;
}
